import { useQuery, useInfiniteQuery } from '@tanstack/react-query';
import { packsApi } from '../services/packsApi';

export const packKeys = {
  all: ['packs'] as const,
  list: () => [...packKeys.all, 'list'] as const,
  packActivitiesInfinite: (packId: number) =>
    [...packKeys.all, 'activities', packId, 'infinite'] as const,
};

export function usePacks() {
  return useQuery({
    queryKey: packKeys.list(),
    queryFn: () => packsApi.getPacks(),
    staleTime: 5 * 60 * 1000,
  });
}

export function useInfinitePackActivities(packId: number | null, pageSize = 10) {
  return useInfiniteQuery({
    queryKey: packKeys.packActivitiesInfinite(packId ?? -1),
    queryFn: ({ pageParam }) => packsApi.getPackActivities(packId!, pageParam, pageSize),
    enabled: packId !== null,
    initialPageParam: 1,
    getNextPageParam: (lastPage) =>
      lastPage.pagination.hasNextPage ? lastPage.pagination.page + 1 : undefined,
  });
}
